<template>
  <v-card class="h-100">
    <v-card-text>
      <v-layout column wrap>
        <v-flex xs12>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex class="p-relative" md10>
                <span class="headline">
                  Por cliente ({{new Intl.NumberFormat('es-VE').format(customers || 0)}})
                </span>
                <actual-button v-if="filters.dateType === 'month'" class="actualButton" :filters="filters"></actual-button>
              </v-flex>
              <v-flex md2>
                <v-layout justify-end>
                  <v-btn
                    class="btn-download"
                    @click="generateReport('best_notitifcation', 'filtersCu')">
                      <v-icon small>fas fa-download</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex class="border mt-2 p-relative">
            <pie-line
              @change-total="customers = $event"
              @update-step="$emit('update-step', $event)"
              :date="dateCs"
              :filters="filtersCu"
              :step="step"
              :initiate="1"
            />
          </v-flex>
        </v-flex>
        <v-flex class="mt-4">
          <v-layout row wrap>
            <v-flex md10>
              <span class="headline">
                Por gestión ({{new Intl.NumberFormat('es-VE').format(notifications || 0)}})
              </span>
            </v-flex>
            <v-flex md2>
              <v-layout justify-end>
                <v-btn
                  class="btn-download"
                  @click="generateReport('managementTotal', 'filtersNs')">
                    <v-icon small>fas fa-download</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-flex class="border mt-2 p-relative">
            <pie-line
              @change-total="notifications = $event"
              @update-step="$emit('update-step', $event)"
              :filters="filtersNs"
              :date="dateNs"              
              :step="step"
              :initiate="1"
            />
          </v-flex> 
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import PieLine from './PieLine/Index';
import ActualButton from '../ActualButton';

export default {
  props: {
    step: {
      type: Number,
      default: 0,
    },
    filters: {
      type: Object,
      default: () => {},
    },
    dateCustomer: {
      type: [String, undefined],
      default: 'No posee',
    },
    dateNotification: {
      type: [String, undefined],
      default: 'No posee',
    },
    dateMCustomer: {
      type: [String, undefined],
      default: 'No posee',
    },
    dateMNotification: {
      type: [String, undefined],
      default: 'No posee',
    },
  },
  components: {
    PieLine,
    ActualButton,
  },
  data() {
    return {
      notifications: 0,
      customers: 0,
    };
  },
  computed: {
    dateCs() {
      return (this.filters.dateType === 'date' ? this.dateCustomer : this.dateMCustomer);
    },
    dateNs() {
      return (this.filters.dateType === 'date' ? this.dateNotification : this.dateMNotification);
    },
    filtersCu() {
      return {
        ...this.filters,
        typeSearch: 'cu',
      };
    },
    filtersNs() {
      return {
        ...this.filters,
        typeSearch: 'ns',
      };
    },
  },
  methods: {
    generateReport(functionName, filters) {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...this[filters],
          },
          functionName,
        },
      });
    },
  },
};
</script>
<style scoped>
.border {
  border: 1px solid #B3B3B2;
}
.p-relative {
  position: relative;
}
.btn-download {
  height: 6vh!important;
  width: 1vw!important;
}
.p-relative >>> .actualButton {
  top: 2vh;
}
</style>



// WEBPACK FOOTER //
// src/components/panelV2/Channels/PieLine.vue